import { Card, CardActionArea, CardContent, Grid, List } from "@mui/material";
import Typography from "antd/es/typography";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import Api from "../API/api";
import { loginState, WHState } from "../Atom/AtomState";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import PublicModal from "../CommonComponent/Modal/PublicModal";
import "../CSS/PageCSS/CustomersPage.css";

const { Title } = Typography;

export default function CustomersPage() {
  let navigate = useNavigate();
  const [customerData, setCustomerData] = useState<any>();
  const WH = useRecoilValue(WHState);
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const [searchInformation, setSearchInformation] = useState({
    name: "",
  });
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [deleteModal, setDeleteModal] = useState({
    value: false,
    p_id: 0,
  });
  const LoginState = useRecoilValue(loginState);
  const [loading, setLoading] = useState(false);

  const changeTextField = (value: any) => {
    if (value.name == "name") {
      setSearchInformation((prev) => ({
        ...prev,
        name: value.value,
      }));
    }
  };

  const handleSearch = () => {
    const getSearch = async () => {
      setLoading(true);
      const customer = await Api.get(
        `/Customer/getCustomerSearch?name=${searchInformation.name}`
      );
      setLoading(false);
      if (customer != undefined) {
        setCustomerData(customer);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getSearch();
  };
  const handleUpdate = (item: any) => {
    if (item.p_id == 1) {
      setAlert(true);
      setAlertMessage("해당 직원은 수정이 불가능합니다.");
    } else {
      navigate("/CustomersDetailPage", {
        state: { p_id: item.p_id, state: "update" },
      });
    }
  };

  useEffect(() => {
    if (!LoginState?.manager) {
      navigate("/");
    } else {
      const getData = async () => {
        setLoading(true);
        const customer = await Api.get("/Customer/getCustomerList");
        setLoading(false);
        if (customer != undefined) {
          setCustomerData(customer);
        } else {
          setAlert(true);
          setAlertMessage("데이터 조회에 실패하였습니다.");
        }
      };
      getData();
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const CustomerssearchTextDiv = document.getElementById(
        "CustomerssearchTextDiv"
      ) as HTMLElement;
      if (div && CustomerssearchTextDiv) {
        setdivBoxHeight(
          div.clientHeight - CustomerssearchTextDiv.clientHeight - 20
        );
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="CustomersTitle">
        CustomersPage
      </Title>
      <div id="divbox">
        <div className="CustomerssearchTextDiv" id="CustomerssearchTextDiv">
          <TextComponent
            variant="filled"
            value={searchInformation.name}
            label="고객이름"
            name="name"
            placeholder="검색어를 입력해주세요."
            onChange={changeTextField}
            className="CustomersSearch"
          />
          <ButtonComponent
            fullWidth
            variant="contained"
            className="CustomerssearchTextDiv_searchButton"
            onClick={handleSearch}
          >
            검색
          </ButtonComponent>
        </div>
        <List
          sx={{
            height: divboxHeight,
          }}
          className="CustomersList"
        >
          <Grid container spacing={2}>
            {customerData &&
              customerData.map((item: any) => {
                return (
                  <Grid
                    key={item.p_id}
                    size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }}
                  >
                    <Card
                      className="CustomersCard"
                      onClick={() =>
                        navigate("/CustomersDetailPage", {
                          state: { p_id: item.p_id, state: "view" },
                        })
                      }
                    >
                      <CardActionArea>
                        <CardContent className="CustomersCardContent">
                          <div>
                            <Title level={5} className="CustomersName">
                              {item.name}
                            </Title>
                          </div>
                          <div className="CustomersControlDiv">
                            <ButtonComponent
                              fullWidth
                              variant="contained"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleUpdate(item);
                              }}
                              className="CustomersUpdateButton"
                            >
                              수정
                            </ButtonComponent>
                          </div>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              })}
          </Grid>
        </List>
      </div>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
